class CapsProductMedia extends HTMLElement {
  connectedCallback() {
    this.initSwipers();
    this.initReductionSync();
  }

  initReductionSync() {
    const syncTag = () => {
      const activeVariant = document.querySelector('.product-form__variants-item.active');
      if (!activeVariant) return;
      const activeTag = activeVariant.querySelector('.product-form__variants--tag:not(.disabled) p');
      this.updateReductionTag(activeTag ? activeTag.textContent.trim() : '');
    };

    // Initial sync
    syncTag();

    // Observe class changes on variants to detect active change
    const variants = document.querySelectorAll('.product-form__variants-item');
    variants.forEach((v) => {
      const observer = new MutationObserver(syncTag);
      observer.observe(v, { attributes: true, attributeFilter: ['class'] });
    });

    // Also listen to clicks on variants (belt + suspenders)
    variants.forEach((v) => v.addEventListener('click', () => setTimeout(syncTag, 0)));
  }

  initSwipers() {
    const thumbsEl = this.querySelector('.caps-product-media__thumbs');
    const mainEl = this.querySelector('.caps-product-media__main');
    if (!thumbsEl || !mainEl) return;

    this.thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      spaceBetween: 6,
    });

    this.mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector('.caps-product-media__nav--next'),
        prevEl: this.querySelector('.caps-product-media__nav--prev'),
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
    });

    this.initThumbsNav();
  }

  initThumbsNav() {
    const fade = this.querySelector('.caps-product-media__thumbs-fade');
    const nav = this.querySelector('.caps-product-media__thumbs-nav');
    if (!fade || !nav) return;

    nav.addEventListener('click', () => this.thumbsSwiper.slideNext());

    const update = () => {
      const isEnd = this.thumbsSwiper.isEnd || this.thumbsSwiper.isLocked;
      fade.classList.toggle('is-hidden', isEnd);
      nav.classList.toggle('is-hidden', isEnd);
    };

    update();
    this.thumbsSwiper.on('slideChange', update);
    this.thumbsSwiper.on('reachEnd', update);
    this.thumbsSwiper.on('reachBeginning', update);
    this.thumbsSwiper.on('fromEdge', update);
    this.thumbsSwiper.on('resize', update);
  }

  goToVariant(variantId) {
    const slides = this.querySelectorAll('.caps-product-media__main .swiper-slide');
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].dataset.variantId == variantId) {
        this.mainSwiper.slideTo(i);
        return;
      }
    }
  }

  goToSlide(index) {
    if (this.mainSwiper) this.mainSwiper.slideTo(index);
  }

  updateReductionTag(text) {
    const tag = this.querySelector('.caps-product-media__tag-item--reduction');
    if (!tag) return;
    if (text) {
      tag.textContent = text;
      tag.style.display = '';
    } else {
      tag.style.display = 'none';
    }
  }
}

customElements.define('caps-product-media', CapsProductMedia);
